import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import axios from "axios";
import { SERVICE_DATA } from "../data/services";
export const assetUrl = (v) =>
  v?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${v}` : v;
export const DEFAULT_NAV = [
  { name: "Home", path: "/" },
  { name: "Back To School", path: "/back-to-school" },
  { name: "Services", path: "/services", hasDropdown: true },
  { name: "About", path: "/about" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: "/contact" },
  { name: "Shop", path: "/shop" },
];
export const shopFor = (slug) =>
  ({
    "school-uniforms": "/back-to-school",
    "greek-apparel": "/shop?category=greek-apparel",
    "business-branding": "/shop?category=business-merch",
    "personalized-gifts": "/shop?category=personalized-gifts",
    graduations: "/shop?category=graduation",
  })[slug] || "/quote/builder";
export const DEFAULT_WEBSITE = {
  logo: "/images/brand/kyis-logo.png",
  navigation: DEFAULT_NAV,
  primary_label: "Shop Now",
  primary_link: "/shop",
  services: {},
};
const Context = createContext({ config: DEFAULT_WEBSITE, refresh: () => {} });
export function WebsiteProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_WEBSITE);
  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/website`,
      );
      setConfig({
        ...DEFAULT_WEBSITE,
        ...data,
        logo: assetUrl(data.logo),
        navigation: data.navigation ?? DEFAULT_NAV,
      });
    } catch {}
  }, []);
  useEffect(() => {
    refresh();
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [refresh]);
  return (
    <Context.Provider value={{ config, refresh }}>{children}</Context.Provider>
  );
}
export const useWebsite = () => useContext(Context);
export function useServices() {
  const { config } = useWebsite();
  return SERVICE_DATA.map((s) => ({
    ...s,
    button_text:
      shopFor(s.slug) === "/quote/builder" ? "Build a Quote" : "Shop Now",
    button_link: shopFor(s.slug),
    ...config.services?.[s.slug],
    image: assetUrl(config.services?.[s.slug]?.image ?? s.image),
    gallery: (config.services?.[s.slug]?.gallery ?? s.gallery ?? []).map(
      (g) => ({ ...g, src: assetUrl(g.src) }),
    ),
  }));
}
